(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("@angular/core"), require("@angular/router"), require("@angular/common"), require("@ngx-translate/core"), require("rxjs/operators"));
	else if(typeof define === 'function' && define.amd)
		define(["@angular/core", "@angular/router", "@angular/common", "@ngx-translate/core", "rxjs/operators"], factory);
	else if(typeof exports === 'object')
		exports["localize-router"] = factory(require("@angular/core"), require("@angular/router"), require("@angular/common"), require("@ngx-translate/core"), require("rxjs/operators"));
	else
		root["localize-router"] = factory(root["@angular/core"], root["@angular/router"], root["@angular/common"], root["@ngx-translate/core"], root["rxjs/operators"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_12__, __WEBPACK_EXTERNAL_MODULE_31__, __WEBPACK_EXTERNAL_MODULE_55__, __WEBPACK_EXTERNAL_MODULE_56__, __WEBPACK_EXTERNAL_MODULE_57__) {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition